import { notifUtils } from "../components/NotifUtils/NotifUtils";
import { handleError } from "../components/Utils/Utils";
import PropertyService from "../Services/PropertyService";

export const getList = (store, value, refresh) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  return PropertyService.getList(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      store.state.lastPage = false;
      store.state.data = refresh ? data : store.state.data.concat(data);
      if (data.length < parseInt(value.num)) {
        store.state.lastPage = true;
      }
      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const store = async (store, value) => {
  try {
    const response = await PropertyService.storeData(value);
    const data = response.data;
    notifUtils("Successfully Created Property", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const put = async (store, value, index) => {
  try {
    const response = await PropertyService.putData(index, value);
    const data = response.data;
    notifUtils("Successfully Updated Property", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const deleted = async (store, query) => {
  try {
    const response = await PropertyService.deleteData(query);
    const data = response.data;
    notifUtils("Successfully Deleted Property", "success");
    return data;
  } catch (error) {
    handleError(error);
    return false;
  }
};
